import WidgetConfigurationSimpleForm from './WidgetConfigurationSimpleForm'

export default WidgetConfigurationSimpleForm
